import { IS_ACCOUNT_DETAIL_PAGE_ENABLED } from '@/utils/constant';

/**
 * Whether the signed-in user sees the account UI: account pages, Account links and account search
 * results. The environment switch turns it on at all; during the Salesforce canary, core marks
 * only canary brokers `accountsCanaryEligible` at login, and every user once the canary is over.
 * An absent value hides it.
 */
export const isAccountUiVisible = (permission?: { accountsCanaryEligible?: boolean } | null): boolean =>
  IS_ACCOUNT_DETAIL_PAGE_ENABLED && permission?.accountsCanaryEligible === true;
